<script lang="ts" setup>
import type { TripMonitorRoute, TripMonitorTravelOrder } from "@/api/trips/dto/trip-monitor";
import type { TripUpdate } from "@/api/trips/dto/update";
import CreateBrokerUpdatePipWindow from "@/views/trips/components/pipWIndows/CreateBrokerUpdatePipWindow.vue";
import ViewUpdateDialog from "@/views/trips/components/dialogs/ViewUpdateDialog.vue";
import { API } from "@/api/api";
import { useSnackbarStore } from "@/store/snackbar.store";
import TripIntervalDialog from "@/views/trips/components/TripIntervalDialog.vue";

const api = new API();
const { showSnackbarError, showSnackbarSuccess } = useSnackbarStore();

const showCreateDialog = defineModel<boolean>("showCreateDialog", { default: false });
const showInfoDialog = defineModel<boolean>("showInfoDialog", { default: false });
const showIntervalDialog = defineModel<boolean>("showIntervalDialog", { default: false });

const props = withDefaults(
  defineProps<{
    tripMonitorRoute?: TripMonitorRoute | null;
    travelOrder?: TripMonitorTravelOrder | null;
    brokerUpdate?: TripUpdate | null;
    tripId?: number | null;
  }>(),
  {
    tripMonitorRoute: null,
    brokerUpdate: null,
    tripId: null,
    travelOrder: null,
  },
);

async function updateInterval(interval: number | null): Promise<void> {
  if (!props.travelOrder || !props.tripId) {
    return;
  }

  try {
    const response = await api.trips.updateTravelOrderInterval(props.tripId, props.travelOrder.id, interval);

    if (response.success) {
      showSnackbarSuccess("Interval saved successfully");
    }
  } catch (error) {
    console.log(error);
    showSnackbarError("Could not save the trip interval");
  }
}
</script>

<template>
  <create-broker-update-pip-window
    v-if="props.tripMonitorRoute && props.tripMonitorRoute.lastCheckCall && props.travelOrder?.id && showCreateDialog"
    v-model="showCreateDialog"
    :check-call-id="props.tripMonitorRoute.lastCheckCall.id"
    :check-call-type="props.tripMonitorRoute.lastCheckCall.type"
    :route-id="props.tripMonitorRoute.id"
    :travel-order-id="props.travelOrder.id"
  />

  <view-update-dialog
    v-if="brokerUpdate && props.tripMonitorRoute?.lastCheckCall && showInfoDialog"
    v-model="showInfoDialog"
    :check-call-type="props.tripMonitorRoute.lastCheckCall.type"
    :update="brokerUpdate"
  />

  <trip-interval-dialog
    v-if="props.tripMonitorRoute && props.travelOrder && showIntervalDialog"
    v-model="showIntervalDialog"
    :interval="props.travelOrder.updateInterval"
    :truck-id="props.tripMonitorRoute.truck.id"
    :truck-number="props.tripMonitorRoute.truck.number"
    title="Broker update settings"
    @update-interval="updateInterval"
  />
</template>

<style lang="scss" scoped></style>
